import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export function useBillingItems(matterId?: string) {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['billing_items', user?.id, matterId],
    enabled: !!user,
    queryFn: async () => {
      let query = supabase.from('billing_items').select('*').order('created_at', { ascending: false });
      if (matterId) query = query.eq('matter_id', matterId);
      const { data, error } = await query;
      if (error) throw error;
      return data;
    },
  });
}

export function useCreateBillingItem() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (item: { matter_id: string; description: string; amount: number; category?: string; due_date?: string }) => {
      const { data, error } = await supabase
        .from('billing_items')
        .insert(item)
        .select()
        .single();
      if (error) throw error;
      return data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['billing_items'] });
    },
  });
}

export function useUpdateBillingItem() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, ...updates }: { id: string; status?: string; paid_at?: string }) => {
      const { data, error } = await supabase
        .from('billing_items')
        .update(updates)
        .eq('id', id)
        .select()
        .single();
      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['billing_items'] });
    },
  });
}
